import React from "react"
import { Cash, CreditCard, Stripe } from "@medusajs/icons"
import { PaypalIcon } from "@/icons";
import { isDev } from "./utils";

let origins = process.env.NEXT_PUBLIC_ALLOW_ORIGINS || ""

export const allowedOrigins = [
  "https://www.fbehk.com",
  "http://localhost:3000",
  "http://localhost:3001",
  "https://aichat.iframe.fbehk.com",
  "http://aichat.b2c.yc",
  "https://www.sandbox.paypal.com",
  "https://sandbox.paypal.com",
].concat(origins.split(",").filter(Boolean));

/* Map of payment provider_id to their title and icon. Add in any payment providers you want to use. */
export const paymentInfoMap: Record<
  string,
  { title: string; icon: React.JSX.Element }
> = {
  "pp_card_stripe-connect": {
    title: "Stripe",
    icon: <Stripe />,
  },
  pp_stripe_stripe: {
    title: "Credit card",
    icon: <Stripe />,
  },
  "pp_stripe-ideal_stripe": {
    title: "iDeal",
    icon: <Stripe />,
  },
  "pp_stripe-bancontact_stripe": {
    title: "Bancontact",
    icon: <Stripe />,
  },
  "pp_paypal_paypal-connect": {
    title: "PayPal",
    icon: <PaypalIcon />,
  },
  pp_system_default: {
    title: "Manual Payment",
    icon: <Cash />,
  },
  // Add more payment providers here
}

// This only checks if it is native stripe for card payments, it ignores the other stripe-based providers
export const isStripe = (providerId?: string) => {
  return typeof providerId === "string" && providerId.startsWith("pp_card_stripe-connect")
}
export const isPaypal = (providerId?: string) => {
  return typeof providerId === "string" && providerId.startsWith("pp_paypal_paypal-connect")
}
export const isManual = (providerId?: string) => {
  return typeof providerId === "string" && providerId.startsWith("pp_system_default")
}

// Add currencies that don't need to be divided by 100
export const noDivisionCurrencies = [
  "krw",
  "jpy",
  "vnd",
  "clp",
  "pyg",
  "xaf",
  "xof",
  "bif",
  "djf",
  "gnf",
  "kmf",
  "mga",
  "rwf",
  "xpf",
  "htg",
  "vuv",
  "xag",
  "xdr",
  "xau",
]

// Data cache revalidation seconds for API requests, should be passed programmatically
export const CACHE_FETCH_API_REVALIDATE_TTL = parseInt(process.env.CACHE_FETCH_API_REVALIDATE_TTL as string) || (isDev ? 0 : 1800);
